import axios from "utils/axios";
import { routes } from "api/routes";
import { modelTrainingChannel } from "utils/constants";

export const apiCreateNewModel = async (newModelData) => {
  const { data } = await axios.post(routes.createNewModel, newModelData);
  return data;
};

export const apiGetModelsList = async (resolution) => {
  const { data } = await axios.get(routes.getModelsList, {
    params: { resolution },
  });
  return data;
};

export const apiDeleteModel = async (
  modelId,
  channel = modelTrainingChannel,
) => {
  const { data } = await axios.delete(routes.deleteModelById, {
    params: { modelId, channel },
  });
  return data;
};

export const apiGetModelDetails = async (modelId) => {
  const { data } = await axios.get(routes.getModelDetails, {
    params: { modelId },
  });
  return data;
};
